export default "__VITE_ASSET__69785858__"